import {get} from "../../../../../assets/js/shared/data-manager";
import Loader from './loader';

export default class RecipePrint {
    constructor($el) {
        this.$trigger = $el;
        this.printViewHtml = null;
        this.abortController = null;
        this.$amountControl = document.querySelector("[data-ingredient-calculator] [data-ingredient-calculator-control]");

        this.getPrintView = this.getPrintView.bind(this);
        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
        this.triggerPrint = this.triggerPrint.bind(this);
        this.loader = (new Loader(document.querySelector('[data-loader]')));

        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;

        this.$trigger.addEventListener('click', this.triggerPrint);
        this.$amountControl.addEventListener('change', this.getPrintView);

        this.getPrintView();
    }

    /**
     * Trigger print
     * @param e
     */
    triggerPrint(e) {
        e.preventDefault();

        // For some reason the default onbeforeprint gets called to late to load the images so we call it here first
        this.beforePrint();

        this.loader.loading(true);
        // and then we wait x amount of time until the images are loaded
        setTimeout(() => {
            this.loader.loading(false);
            window.print();
            this.afterPrint();
        },1000);
    }

    /**
     * handle before print
     */
    beforePrint() {
        if (! this.printViewHtml) {
            console.error('No print view html available');
            return;
        }

        if (document.querySelector("[data-recipe-print-view]")) {
            console.info('print view already exits');
            return;
        }

        // Construct a element where we will add the print content
        const $printViewElement = document.createElement('div');
        $printViewElement.setAttribute('data-recipe-print-view', true);
        $printViewElement.classList.add('print-view');
        $printViewElement.innerHTML = this.printViewHtml;

        // Add the print content to the page
        document.body.append($printViewElement);
        // Hide the full page content from print except html wrapping
        document.querySelector("[data-page-wrapper]").classList.add('hide-print');
    }

    /**
     * handle after print
     */
    afterPrint() {
        // remove print view
        document.querySelector("[data-recipe-print-view]")?.remove();
        // show content back for print
        document.querySelector("[data-page-wrapper]")?.classList.remove('hide-print');
    }

    /**
     * Get print view
     *
     * @return {Promise<void>}
     */
    async getPrintView() {
        if ( ! placeholders.publication || ! placeholders.publication.slug) {
            console.error('No publication or publication slug was found in the placeholders');
        }

        if (this.abortController) {
            this.abortController.abort();
        }

        this.abortController = new AbortController();
        const params = {
            amount: this.$amountControl.value
        };
        const fetchUrl = `${placeholders.baseUri}/ajax/blueprint-unwrapped/recipe-print-detail/${placeholders.publication.slug}`;
        const result = await get(fetchUrl, params, this.abortController.signal);

        if (! result?.success) {
            console.error('No html delivered for recipe print view');
            return;
        }

        this.printViewHtml = result.html;
    }
}